<div
  class="statistic border tw-relative tw-my-3 bg-white tw-flex tw-justify-between tw-items-center flex-column tw-h-full"
>
  <div class="tw-w-full">
    <h2
      class="text-navyBlue tw-mt-[35px] tw-mb-4 tw-pb-5 border-bottom tw-font-semibold tw-text-[16px] tw-mx-4"
    >
      {{ model?.name }}
    </h2>

    <div class="tw-flex-center tw-mt-4">
      <ul class="tw-mx-5 tw-w-full">
        <div class="2xl:tw-mx-6 xl:tw-mx-4">
          <!-- messagesCount -->
          <li
            class="tw-flex tw-justify-between tw-items-center tw-py-1 tw-my-1 border-bottom tw-px-2"
          >
            <span
              class="tw-text-gray-600 dark:tw-text-gray-100 tw-font-normal text-md tw-mx-2 tw-my-2 tw-text-[13px]"
              >{{ "common.messageCount" | translate }}
            </span>
            <b
              class="tw-font-medium tw-px-1 tw-text-gray-800 dark:tw-text-gray-300 tw-text-[14px]"
              >{{ model?.messagesCount | numberSeparator }}</b
            >
          </li>

          <!-- messageInConsumeCount -->
          <li
            class="tw-flex tw-justify-between tw-items-center tw-py-1 tw-my-1 border-bottom tw-px-2"
          >
            <span
              class="tw-text-gray-600 dark:tw-text-gray-100 tw-font-normal text-md tw-mx-2 tw-my-2 tw-text-[13px]"
              >{{ "common.messageInConsumeCount" | translate }}
            </span>
            <b
              class="tw-font-medium tw-px-1 tw-text-gray-800 dark:tw-text-gray-300 tw-text-[14px]"
              >{{ model?.messageInConsumeCount | numberSeparator }}</b
            >
          </li>

          <!-- consumersCount -->
          <li
            class="tw-flex tw-justify-between tw-items-center tw-py-1 tw-mt-1 tw-mb-4 tw-px-2"
          >
            <span
              class="tw-text-gray-600 dark:tw-text-gray-100 tw-font-normal text-md tw-mx-2 tw-my-2 tw-text-[13px]"
              >{{ "common.consumersCount" | translate }}
            </span>
            <b
              class="tw-font-medium tw-px-1 tw-text-gray-800 dark:tw-text-gray-300 tw-text-[14px]"
              >{{ model?.consumersCount | numberSeparator }}</b
            >
          </li>
        </div>

        <div class="tw-grid tw-grid-cols-2 2xl:tw-gap-4 tw-gap-2">
          <!-- consumeRatePerSecond -->
          <div
            class="2xl:tw-h-24 xl:tw-h-20 tw-border-2 tw-rounded-[5px] tw-border-green-600 tw-bg-green-100 dark:tw-bg-[#16241c] dark:tw-border-[#14532d] tw-relative"
          >
            <div
              class="tw-flex tw-items-center tw-justify-center tw-top-[-14px] tw-left-[12px] tw-rounded-[5px] tw-bg-green-600 dark:tw-bg-green-900 tw-absolute"
            >
              <div class="tw-flex tw-items-center tw-justify-center tw-px-3">
                <i class="mdi mdi-plus tw-text-xs tw-text-white"></i>
                <i class="mdi mdi-arrow-up tw-text-xl tw-text-white"></i>
              </div>
            </div>
            <div
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-5"
            >
              <span
                class="2xl:tw-text-base xl:tw-text-sm sm:tw-text-xs tw-text-base tw-font-medium tw-whitespace-nowrap tw-text-green-600 dark:tw-text-green-200"
              >
                {{ "common.consumeRatePerSecond" | translate }}
              </span>
              <b
                class="tw-font-semibold tw-px-1 tw-text-gray-700 dark:tw-text-gray-300 tw-text-[17px]"
                >{{ model?.consumeRatePerSecond | numberSeparator }}</b
              >
            </div>
          </div>

          <!-- incomeRatePerSecond -->
          <div
            class="2xl:tw-h-24 xl:tw-h-20 tw-border-2 tw-rounded-[5px] tw-border-red-500 tw-bg-red-100 dark:tw-bg-[#2f1212] dark:tw-border-[#5a1c1c] tw-relative"
          >
            <div
              class="tw-flex tw-items-center tw-justify-center tw-top-[-14px] tw-left-[12px] tw-rounded-[5px] tw-bg-red-500 dark:tw-bg-[#5a1c1c] tw-absolute"
            >
              <div class="tw-flex tw-items-center tw-justify-center tw-px-3">
                <i class="mdi mdi-minus tw-text-xs tw-text-white"></i>
                <i class="mdi mdi-arrow-down tw-text-xl tw-text-white"></i>
              </div>
            </div>
            <div
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-5"
            >
              <div
                class="2xl:tw-text-base xl:tw-text-sm sm:tw-text-xs tw-text-base tw-font-medium tw-whitespace-nowrap text-danger dark:!tw-text-red-200"
              >
                {{ "common.incomeRatePerSecond" | translate }}
              </div>
              <b
                class="tw-font-semibold tw-px-1 tw-text-gray-700 dark:tw-text-gray-300 tw-text-[17px]"
                >{{ model?.incomeRatePerSecond | numberSeparator }}</b
              >
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</div>
